export default __webpack_public_path__ + "static/image2-b93a49a190ae258ef2724f2ed0fac0b9.png";